import { ChevronDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";

export function MultiFilter({ label, options, value, onChange, testId }) {
  const text = value.length === options.length ? "Todos" : value.length ? options.filter(([k]) => value.includes(k)).map(([, l]) => l).join(", ") : "Nenhum";
  const toggle = (k) => onChange(value.includes(k) ? value.filter((x) => x !== k) : [...value, k]);
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" className="flex h-10 w-full items-center justify-between gap-2 rounded-md border bg-transparent px-3 text-left text-sm sm:w-[200px]" data-testid={testId}>
          <span className="min-w-0"><span className="block text-[10px] uppercase leading-none tracking-wider text-muted-foreground">{label}</span><span className="block truncate">{text}</span></span>
          <ChevronDown className="h-4 w-4 shrink-0 opacity-60" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-2" align="start">
        {options.map(([k, l]) => (
          <label key={k} className="flex cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-sm hover:bg-muted">
            <Checkbox checked={value.includes(k)} onCheckedChange={() => toggle(k)} data-testid={`${testId}-${k}`} />{l}
          </label>
        ))}
      </PopoverContent>
    </Popover>
  );
}
